const initialState = {
  isAuthenticated: false,
  loading: false,
  user: null,
  error: null,
  activePermission: null, // nuevo
  permissions: {
    loading: false,
    data: null,
    error: null,
  },
};
  
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'PERMISSIONS_REQUEST':
      return { ...state, permissions: { ...state.permissions, loading: true, error: null }, };
    case 'PERMISSIONS_SUCCESS':
      return { ...state, permissions: { loading: false, error: null, data: action.payload }, };
    case 'PERMISSIONS_FAIL':
      return { ...state, permissions: { ...state.permissions, loading: false, error: action.payload  }, };
    case 'SET_ACTIVE_PERMISSION':
      return { ...state, activePermission: action.payload,};
    
    case 'LOGIN_REQUEST':
      return {...state, isAuthenticated: false, loading: true, error:null };
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        isAuthenticated: true,
        loading:false,
        user: action.payload,
        error: null
      };
    case 'LOGIN_FAIL':
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        loading:false,
        error: action.payload,
      };
    
    case 'LOGOUT':
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default authReducer;
